import React from "react";
import { ReserveFieldDuration } from "@/features/reserve/components/ReserveFieldDuration/ReserveFieldDuration";
import { useReserveForm } from "../ReserveFormProvider";

export const ReserveFormDuration: React.FC = () => {
  const { form, startTime, durationOptions, setDurationMins, defaultValues } =
    useReserveForm();
  return (
    <ReserveFieldDuration
      form={form}
      startTime={startTime}
      setDurationMin={setDurationMins}
      durationOptions={durationOptions}
      defaultValue={defaultValues.duration}
      errors={form.formState.errors}
    />
  );
};
